var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nuxt-link',{class:{'has-address': _vm.location},attrs:{"to":_vm.cartLink}},[_c('icon-cart')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }